import React, { useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { Search, Target } from "lucide-react";
import { NAV_RUBRIQUES, type NavRubriqueKey } from "../../helpers/navCatalog.generated";
import { NAV_ICONS } from "../../helpers/navIcons";
import { initTabbar } from "../../nav/navBar";

/** Barre mobile : Mes grilles remplace Recherche pour un connecté (D2), la loupe reste dans l'en-tête. */
export const SiteTabbar = ({ active, onOpenSearch, connecte = false }: { active: NavRubriqueKey | null; onOpenSearch: () => void; connecte?: boolean }) => {
  const ref = useRef<HTMLElement>(null);
  const { pathname } = useLocation();
  useEffect(() => { initTabbar(ref.current); }, []);
  return (
    <nav className="km-tabbar" aria-label="Navigation mobile" data-nav-emplacement="barre_mobile" ref={ref}>
      {NAV_RUBRIQUES.filter((r) => r.key !== "guides").map((r) => {
        const Icon = NAV_ICONS[r.icon];
        return (
          <a key={r.key} href={r.hubPath} data-nav-rubrique={r.key} aria-current={active === r.key ? "page" : undefined}>
            {Icon && <Icon aria-hidden="true" />}<span>{r.shortLabel}</span>
          </a>
        );
      })}
      {connecte
        ? <Link to="/mon-keno/" aria-current={pathname.startsWith("/mon-keno") ? "page" : undefined}><Target aria-hidden="true" /><span>Mes grilles</span></Link>
        : <button type="button" onClick={onOpenSearch}><Search aria-hidden="true" /><span>Recherche</span></button>}
    </nav>
  );
};
